export const getColor = (chartColors, index, itemsLength) => {
  const normalizedIndex = index % chartColors.length;

  if (normalizedIndex === 0 && index === itemsLength - 1 && itemsLength > 1) {
    return chartColors[Math.min(chartColors.length - 1, 1)];
  }

  return chartColors[normalizedIndex];
};
